module.exports = __webpack_public_path__ + "img/14_Low-body+LC.461daa3e.png";